import { render, staticRenderFns } from "./UploadEnclosureBottom.vue?vue&type=template&id=ac6d2446&scoped=true"
import script from "./UploadEnclosureBottom.vue?vue&type=script&lang=ts"
export * from "./UploadEnclosureBottom.vue?vue&type=script&lang=ts"
import style0 from "./UploadEnclosureBottom.vue?vue&type=style&index=0&id=ac6d2446&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6d2446",
  null
  
)

export default component.exports